// extracted by mini-css-extract-plugin
export default {"description-list":"_3BK4IQtY8v","descriptionList":"_3BK4IQtY8v","container":"_29anHb4uGq","term":"_24vAQ8pVys","value":"_3LwWz0lfe1","empty-byte":"_202tiy4qMd","emptyByte":"_202tiy4qMd","highlight":"tFsRDdTneJ"};
    if(module.hot) {
      // 1627035646406
      var cssReload = require("!../../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  